import React, { useCallback } from "react";
import { css } from "glamor";
import { colors, Link, spacing } from "../library";
import { downloadCertificate } from "../../processes/certificateProcesses";

const linkClass = css({
  color: colors.primary,
  display: "flex",
  justifyContent: "end",
  paddingRight: spacing.m,
});
const disabledLink = {
  color: colors.greyLight,
  cursor: "normal",
};

export default function CertificateDownloadLink({ object, disabled }) {
  const handleDownload = useCallback(() => {
    downloadCertificate(object?.certificatePath);
  }, [object?.certificatePath]);

  return (
    <div>
      {disabled ? (
        <p className={css(linkClass, disabledLink)}>Download</p>
      ) : (
        <Link onClick={handleDownload} className={linkClass}>
          Download
        </Link>
      )}
    </div>
  );
}
